var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"copyright"},[_vm._v("© 2024 "+_vm._s(_vm.siteName)+" 版权所有")]),_c('p',{staticClass:"slogan"},[_vm._v("动漫爱好者的资料宝库")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }